@if (shouldRender()) {
  <div class="flex w-full items-center gap-2 pr-2">
    <pxc-form-question-input
      class="min-w-0 flex-1"
      mode="grid"
      [control]="control()!"
      [question]="questionState()!"
      [readOnly]="isReadonly()" />
    @if (questionModules().length) {
      <pxc-form-grid-trigger
        placement="question"
        [moduleInputs]="moduleInputs()"
        [modules]="questionModules()"
        [targetId]="question().id"
        (moduleReset)="resetModule($event)"
        (moduleTriggered)="applyModule($event)" />
    }
    <pxc-form-grid-cell-error [control]="control()!" [questionState]="questionState()!" />
  </div>
}
